import { injectable } from 'inversify';
import type { IChannel } from '../Channel/types';
import { WS_MESSAGE_TYPE } from '../../../websockets';
import { IRPCMessage } from './types';

@injectable()
class RPCMessage<T> implements IRPCMessage<T> {
  constructor(
    public readonly channel: IChannel,
    public readonly messageType: WS_MESSAGE_TYPE,
    public readonly meta?: T,
  ) {}
}

export default RPCMessage;
